import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { useSelector, useDispatch } from "react-redux";
import { fetchTopActiveJobsRequest } from "../../../redux/recruiter/fetch_top_active_jobs/actions";

const TopActiveJobs = ({ reportType }) => {
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  useEffect(() => {
    dispatch(fetchTopActiveJobsRequest({ year: selectedYear, reportType: reportType }));
  }, [dispatch, selectedYear, reportType]);

  const fetchTopActiveJobsReducerData = useSelector((state) => state.fetchTopActiveJobsReducer);

  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: "area",
      height: 350,
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ],
      labels: {
        show: true,
        style: {
          colors: "#9aa0ac",
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          colors: "#9aa0ac",
          fontSize: "12px",
        },
      },
    },
    tooltip: {
      enabled: true,
      theme: "dark",
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      fontSize: "14px",
      offsetX: 20,
      labels: {
        colors: "#9aa0ac",
      },
    },
    colors: ["#7367F0", "#28C76F", "#EA5455"],
  });

  const [chartSeries, setChartSeries] = useState([]);

  useEffect(() => {
    if (
      !fetchTopActiveJobsReducerData.isLoading &&
      fetchTopActiveJobsReducerData.data &&
      fetchTopActiveJobsReducerData.data.data
    ) {
      const data = fetchTopActiveJobsReducerData.data.data;
      console.log("data11", data);

      // Extract relevant data for chart series
      const application_status = data.map(item => Number(item.all_applications) || 0);
      const shortlisted_status = data.map(item => Number(item.shortlisted) || 0);
      const rejected_status = data.map(item => Number(item.rejected) || 0);

      // Update chart series
      setChartSeries([
        {
          name: "Applications",
          data: application_status,
        },
        {
          name: "Shortlisted",
          data: shortlisted_status,
        },
        {
          name: "Rejected",
          data: rejected_status,
        },
      ]);
    }
  }, [fetchTopActiveJobsReducerData]);

  return (
    <Card className="shadow-sm rounded">
      <CardHeader className="card-no-border">
        <h5 className="mb-0">Applicants Status</h5>
      </CardHeader>
      <CardBody className="px-3 py-3 pt-0">
        <select
          value={selectedYear}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
          className="form-select form-select-sm"
          style={{ width: 'auto', display: 'inline-block', marginLeft: '10px' }}
        >
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
        <div id="basic-apex">
          <ReactApexChart
            options={chartOptions}
            series={chartSeries}
            height="350"
            type="area"
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default TopActiveJobs;